import formatCaptions from './formatCaptions';
import themeEditor from './themeEditor';

export default () => {
  formatCaptions();
  themeEditor();
};